import { SET_CUSTOMERS, SET_CUSTOMERS_LOADING, SET_CUSTOMERS_ERROR } from "../../actions/customerAction";

var initialState = {
  datas: [],
  loading: false,
  error: null,
};

const customerReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_CUSTOMERS:
      return {
        ...state,
        datas: action.data,
      };

    case SET_CUSTOMERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_CUSTOMERS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default customerReducer;
